<template>
    <v-dialog
        max-width="600"
        v-model="openMovePlanDialog"
    >
        <v-card>
            <v-card-title class="primary white--text">
                <v-icon class="mr-2" color="white">content_copy</v-icon>
                Copy or Move Planned Task
            </v-card-title>
            <v-card-text>

                <div class="flex-radio-center">
                    <v-radio-group
                        row
                    >
                        <v-radio
                        label="Copy"
                        value="copy"
                        class="mr-9"
                        small
                        ></v-radio>
                        <v-radio
                        label="Move"
                        value="move"
                        class="ml-9"
                        small
                        ></v-radio>
                    </v-radio-group>
                </div>

                <v-select
                dense
                hide-details
                justify="center"
                class="mt-3"
                label="Select a target folder"
                :items="dropdownValue"
                item-text="node.name"
                item-value="node.id"
                v-model="targetFolderToCopy"
                ></v-select>
            </v-card-text>
            <v-card-actions class="justify-end">
                <v-btn
                    text
                    @click="$emit('closeMoveTaskDialog')"
                >
                    Close
                </v-btn>
                <v-btn
                color="primary"
                rounded
                outlined
                dense
                >Confirm</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default{
        name : "MovePlannedTaskDialog",
        props : ["dropdownValue" , "openMovePlanDialog"],
        data(){
            return {
                planFolders : [],
                openDialog : this.openMovePlanDialog,
                targetFolderToCopy : null,
            }
        },
        methods : {

        },
        watch:{
            // targetFolderToCopy(){
            //     console.log(this.targetFolderToCopy)
            // }
        }
    }
</script>

<style scoped>
.selectDropdown {
    max-width:60%;
    margin-left: 20%;
    margin-right:20%
}

.flex-radio-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>